// This is a modal for Adminpayments

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateReferralpayments } from "./redux/slices/ReferralpaymentsThunks";

export default function ModalAdminpaymentsEdit({ onClose, referrals, active }) {
  const dispatch = useDispatch();
  const [referral_id, setReferralID] = useState(active?.referral_id);
  const [payment, setPayment] = useState(active?.reward);

  const handler = async () => {
    const data = {
      _id: active?._id,
      amount_paid: payment,
    };
    await dispatch(updateReferralpayments(data));
    onClose();
  };

  return (
    <RootWrapperModalAdminpayments>
      <Overlay>
        <Wrapper>
          <StatusUpdate>
            <Left>
              <Frame58>
                <Frame1391>
                  <Frame1527>
                    <Frame1527_0001>
                      <AddPayment>Add Payment</AddPayment>
                    </Frame1527_0001>
                  </Frame1527>
                  <PleaseUpdateTheStatusOfThisReferralBasedOnCurrentInformation>
                    Please update the status of this referral based on current
                    information.
                  </PleaseUpdateTheStatusOfThisReferralBasedOnCurrentInformation>
                </Frame1391>
                <Frame1391>
                  <PRTNR.Select
                    label="Referral ID"
                    options={referrals}
                    value={referral_id}
                  />

                  <PRTNR.Input
                    label="Amount"
                    type="number"
                    value={payment}
                    required={true}
                    onChange={(e) => {
                      setPayment(e.target.value);
                    }}
                  />
                </Frame1391>
                <Frame59>
                  <AIMEButton
                    size="small"
                    onClick={() => {
                      setPayment(0);
                      setReferralID("");
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      background: "rgb(241, 245, 249)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "rgb(33, 37, 67)",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      Cancel
                    </span>
                  </AIMEButton>

                  <AIMEButton
                    size="small"
                    onClick={() => {
                      handler();
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      gap: "10px",
                      borderRadius: "48px",
                      width: "240px",
                      background: "rgb(97, 98, 197)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      Save
                    </span>
                  </AIMEButton>
                </Frame59>
              </Frame58>
            </Left>
          </StatusUpdate>
        </Wrapper>
      </Overlay>
    </RootWrapperModalAdminpayments>
  );
}

const RootWrapperModalAdminpayments = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;

const StatusUpdate = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 610px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 610px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1527 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1527_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 610px;
  box-sizing: border-box;
`;

const AddPayment = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  width: 612px;
  flex: 1;
`;

const PleaseUpdateTheStatusOfThisReferralBasedOnCurrentInformation = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
